import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useUserStore } from '@entities/user';
import { takeReturnTo } from './returnTo';

interface GuestOnlyProps {
  children: ReactNode;
}

/**
 * Если юзер уже залогинен — не показывает /login, /register и т.д.,
 * а возвращает туда, откуда его увели на вход (или на Главную).
 */
export function GuestOnly({ children }: GuestOnlyProps) {
  const user = useUserStore((s) => s.user);
  if (user) {
    return <Navigate to={takeReturnTo()} replace />;
  }
  return <>{children}</>;
}
